import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createPaymentDocument = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/Payments/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.paymentPostedDateTime = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getBackPayment = await db.doc(`/Payments/${uniqueId}`);
    await getBackPayment.get().then(result => {
        localStorage.setItem("temp_id",result?.id)
        if(result?.id) {
            return true;
        } else {
            return false
        }
    });
    
}

export const getPaymentDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Payments').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPaymentDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Payments').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPaymentDetailsWithPaymentId = async (paymentId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Payments').where("paymentId", "==", paymentId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPaymentDetailsWithMobileNumber = async (mobileNumber) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Payments').where("phone", "==", mobileNumber).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPaymentDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let payemnt = null;
    let retailer = null;
    const payemntSnapshot = await db.collection('Payments').where("uniqueId", "==", uniqueId).get()
    payemntSnapshot.docs.map(doc => {
        payemnt = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", payemnt.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        payemnt: payemnt,
        retailer: retailer
    }
}

export const getAllPaymentDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Payments').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updatePaymentDocument = async (payemnt) => {
    localStorage.setItem("temp_id",'');
    localStorage.removeItem("temp_id");
    const docRef = db.doc(`/Payments/${payemnt._id}`);
    return docRef.update(payemnt);
}